import { z } from 'zod'
import { Currency } from '~library/enums'
import { programFeedbackSchema } from './program-feedback'

export const getThresholdCourtesySchema = z.object({
  /** 方案名稱[英文] */
  englishName: z.string(),
  /** 方案名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 方案名稱[繁體中文] */
  traditionalName: z.string(),
  /** 檻次資料 */
  programFeedback: z.array(programFeedbackSchema),
  /** 幣別 */
  currency: z.nativeEnum(Currency)
})

export interface GetThresholdCourtesy
  extends z.infer<typeof getThresholdCourtesySchema> {}
